import { useService } from './useService';

/**
 * Hook to get apiBaseUrl
 * To be used in other hooks like useFlowCategories
 */
export const useApiBaseUrl = () =>
  useService<AppConfig>('APP_CONFIG').apiBaseUrl;
